import { render } from "./EnterDate.vue?vue&type=template&id=472b383a"
import script from "./EnterDate.vue?vue&type=script&lang=js"
export * from "./EnterDate.vue?vue&type=script&lang=js"
script.render = render

export default script